var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { systemSxFromProps } from '../system';
/* Font Family */
export var fontFamily = ['fontFamily'];
/* Font Size */
export var fontSize = ['fontSize'];
/* Font Weight */
export var fontWeight = ['fontWeight'];
/* Typography */
export var typography = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], fontFamily, true), fontSize, true), fontWeight, true), [
    'lineHeight',
    'letterSpacing',
    'textAlign',
    'fontStyle',
], false);
/**
 * Convenience method for forwarding styles from the `typography` system key
 * @see systemSxFromProps
 */
export var typographySxFromProps = function (props) {
    return systemSxFromProps(props, typography);
};
